import React from 'react';
import { Icons } from '../../Common';
import { Size } from '../../Common/Icons';
const AlarmStatus = {
  Active: 'active'
};

const AlarmIcon = ({ status, isAcknowledged }) => {
  const isActive = status === AlarmStatus.Active;

  // const text = isActive ? T.alarm.status.tooltip.active : T.alarm.status.tooltip.inactive;
  // const tooltipText = format(text, acknowledgedBy, DateTime.fromISO(acknowledgedTime).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS));

  return (
    <div className="alarm-icon-container">
      <div
        className={isActive ? 'alarm-icon-active' : 'alarm-icon-inactive'}
      >
        <div>
          <Icons.Notification size={Size.XL}/>
          { isAcknowledged
            ? <Icons.Checkmark className="alarm-item-check" size={Size.SMALL} style={{ fill: '#0a0' }}/>
            : <></>
          }
        </div>
      </div>
    </div>
  );
};

export default AlarmIcon;
